import * as CONSTANTS from '../modules/constants';
import 'string.prototype.endswith';
import { svgInject } from '../modules/svg-injection';
import { loginState } from '../modules/login-state';
import { stickyHeader } from '../modules/sticky-header';
import { nodeListToArray } from '../modules/nodelist-to-array';
import { CurtainMenu } from '../modules/curtain-menu';
import { AriaToggling } from '../modules/aria-click-toggling';
import { IeDesaturate } from '../modules/ie-desaturate';
import { alertMessage } from '../modules/alert-message';
import { Accordions } from '../../../Lib/Lib-Javascript/accordion/accordions';
import { DateListingBlock } from '../modules/date-listing-block';
import { PublicityImageBlock } from '../modules/publicity-image-block';
import setUpSubsToggling from '../modules/subs-toggle-hidden';
import * as A11yDialog from 'a11y-dialog';
import { lockBody, unlockBody } from '../modules/lock-body';
import { ScrollspyNavbar } from '../modules/scrollspy-navbar';
import * as SmoothScroll from 'smooth-scroll';
import { MultimediaLayout } from '../modules/multimedia-layout';
import '../modules/init-swiper';
import { enhanceEpiForms } from '../modules/epi-forms';

// Self-contained, self-invoking function.
(function() {
    loginState();

    // Request SVG sprite
    let spritePath = (window as any).SVG_SPRITE_PATH || '/Static/imgs/svg-sprite.svg';
    svgInject(spritePath);

    CONSTANTS.GLOBAL_HTML.classList.remove('no-js');

    stickyHeader();

    // Full Screen Curtain Menu
    new CurtainMenu(CONSTANTS.GLOBAL_BODY);
    new AriaToggling(nodeListToArray(document.querySelectorAll('#mainNav .nav-main-list-item > .nav-sub-trigger')));

    // Greyscale Images for IE 10 and IE 11
    new IeDesaturate(CONSTANTS.GLOBAL_HTML);

    alertMessage();
    setUpSubsToggling('subs-container-js');

    // Accordion
    new Accordions();

    // Date Listing Block
    new DateListingBlock();

    // Publicity Image Block
    new PublicityImageBlock();

    // Subs seating chart modal
    const globalModals = Array.prototype.slice.call(document.querySelectorAll('.modal-js')) as Array<Element>;
    if (globalModals.length > 0) {
        let modalList = [];
        globalModals.forEach(modal => {
            var modalInstance = new A11yDialog(modal);

            modalList.push(modalInstance);

            modalInstance.on('show', (dialog, e) => {
                lockBody();
            });

            modalInstance.on('hide', (dialog, e) => {
                unlockBody();
            });

            if (modal.getAttribute('data-modal-show')) {
                modalList[modalList.length - 1].show();
            }
        });
    }

    new ScrollspyNavbar();

    new MultimediaLayout('.multimedia-block .block-body');

    var scroll = new SmoothScroll('a[href*="#"]', {
        // Selectors
        ignore: '[data-scroll-ignore], .crt-popup-wrapper', // Selector for links to ignore (must be a valid CSS selector)
        header: '#siteHeader', // Selector for fixed headers (must be a valid CSS selector)

        // Speed & Easing
        speed: 500, // Integer. How fast to complete the scroll in milliseconds
        offset: 0, // Integer or Function returning an integer. How far to offset the scrolling anchor location in pixels
        easing: 'easeInOutCubic', // Easing pattern to use

        // Callback API
        before: function(anchor, toggle) {}, // Callback to run before scroll
        after: function(anchor, toggle) {} // Callback to run after scroll
    });

    // My Membership Benefits toggle
    const benefitsContent = document.getElementById('my-benefits');
    const benefitsContentTrigger = document.getElementById('my-benefits-trigger');

    if (benefitsContentTrigger) {
        benefitsContentTrigger.addEventListener('click', e => {
            if (benefitsContent.classList.contains('visually-hidden')) {
                benefitsContent.classList.remove('visually-hidden');
                benefitsContentTrigger.innerText = 'Hide Details';
            } else {
                benefitsContent.classList.add('visually-hidden');
                benefitsContentTrigger.innerText = 'Show Details';
            }
        });
    }

    //EPI Forms
    if (document.querySelector('.EPiServerForms')) {
        enhanceEpiForms();
    }

    // Add / Update a key-value pair in the URL query parameters
    function updateUrlParameter(uri, key, value) {
        // remove the hash part before operating on the uri
        var i = uri.indexOf('#');
        var hash = i === -1 ? '' : uri.substr(i);

        uri = i === -1 ? uri : uri.substr(0, i);

        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';

        if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            uri = uri + separator + key + '=' + value;
        }

        // finally append the hash as well
        return uri + hash;
    }

    // Login Link Return URL
    const loginLink: HTMLAnchorElement = document.querySelector('.nav-utility-loggedout-js > a');
    const currentURL: any = document.location.href;
    const isTNEW = document.querySelector('.tnew-container') !== null;

    if (currentURL.endsWith('/cart/') || isTNEW) {
        if (!currentURL.endsWith('logout.aspx') && !currentURL.endsWith('/my-account') && !currentURL.endsWith('/my-account/')) {
            const currentLoginLink = loginLink.getAttribute('href');
            const newLoginLink = updateUrlParameter(currentLoginLink, 'ReturnURL', encodeURIComponent(currentURL));

            loginLink.setAttribute('href', newLoginLink);
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/common/global.ts